var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.is,{tag:"component",staticClass:"sub-item",attrs:{"to":_vm.to,"href":_vm.href},on:{"click":function($event){return _vm.$emit('click')}}},[_c('span',{staticClass:"sub-item__text"},[_vm._v(_vm._s(_vm.text))]),_vm._t("aside")],2)}
var staticRenderFns = []

export { render, staticRenderFns }